import BigNumber from 'bignumber.js'

import type { UserTradingAnalyticsPerformanceDto } from '@root/shared/api/TradeApi'

export interface UserTradingAnalyticsPerformance {
  totalPnlUsd: BigNumber
  realizedPnlUsd: BigNumber
  unrealizedPnlUsd: BigNumber
  unrealizedPnlNative: BigNumber
  totalPnlNative: BigNumber
  realizedPnlNative: BigNumber
  tradedPairs: number
  closedPairs: number
  winningClosedPairs: number
  winRate: number
  avgHoldSeconds: number
  pnlDistribution: UserTradingAnalyticsPerformancePnlDistribution

  totalPnlUsdChangePercent: number | undefined
  realizedPnlUsdChangePercent: number | undefined
  unrealizedPnlUsdChangePercent: number | undefined
  winRateChangePercent: number | undefined
}

export interface UserTradingAnalyticsPerformancePnlDistribution {
  over500: number
  from200to500: number
  from0to200: number
  from0toNeg50: number
  belowNeg50: number
}

export const fromDto = (
  dto: UserTradingAnalyticsPerformanceDto,
): UserTradingAnalyticsPerformance => {
  return {
    totalPnlUsd: BigNumber(dto.totalPnl.usd),
    realizedPnlUsd: BigNumber(dto.realizedPnl.usd),
    unrealizedPnlUsd: BigNumber(dto.unrealizedPnl.usd),
    unrealizedPnlNative: BigNumber(dto.unrealizedPnl.native),
    totalPnlNative: BigNumber(dto.totalPnl.native),
    realizedPnlNative: BigNumber(dto.realizedPnl.native),
    tradedPairs: dto.tradedPairs,
    closedPairs: dto.closedPairs,
    winningClosedPairs: dto.winningClosedPairs,
    winRate: dto.winRate,
    avgHoldSeconds: dto.avgHoldSeconds,
    pnlDistribution: { ...dto.pnlDistribution },
    totalPnlUsdChangePercent: dto.totalPnlChangePercent ?? undefined,
    realizedPnlUsdChangePercent: dto.realizedPnlChangePercent ?? undefined,
    unrealizedPnlUsdChangePercent: dto.unrealizedPnlChangePercent ?? undefined,
    winRateChangePercent: dto.winRateChangePercent ?? undefined,
  }
}
